import { Stack, Box, Button, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { StageCardFormValues } from "@/types/Card";

import GeneralPreview from "../../../components/Dashboard/Talent/Card/Card_Creation/Preview/GenralPreview";
import { getImageSrc } from "../../../utils/helper";

import VideoPreview from "../../../components/Dashboard/Talent/Card/Card_Creation/Preview/VideoPreview";
import { Gallery } from "../../../components/Dashboard/Talent/Card/TalentCardDesign/TalentCardDetailPage/Gallery_updated";
//import { Gallery } from "../TalentCardDesign/TalentCardDetailPage/Gallery";
import VisibilitySelector from "../../../components/Dashboard/Talent/Card/Card_Creation/Preview/VisibilitySelector";
import StageCardPreview from "../preview/StageCardPreview";
import StageVideoPreview from "../preview/StageCardVideoPreview";

interface StepThreeProps {
  onBack: () => void;
  onSubmit: () => void;
}

const StepFour_StageReviewAndPublish = ({
  onBack,
  onSubmit,
}: StepThreeProps) => {
  const { values, handleSubmit, setFieldValue, errors, isSubmitting } =
    useFormikContext<StageCardFormValues>();

  const galleryImages = values.galleryImages?.map((img) =>
    typeof img === "string" ? img : URL.createObjectURL(img)
  );

  return (
    <Box fontFamily="Lexend">
      <Stack direction="row" justifyContent="space-between" mb={4}>
        <Typography
          variant="h5"
          fontWeight={700}
          textAlign="start"
          fontFamily="Lexend"
          mb={3}
          sx={{ color: "#333", pt: 3, pb: 2 }}
        >
          Review and Publish
        </Typography>
        <VisibilitySelector
          visibility={values.visibility === "public" ? "Public" : "Private"}
        />
      </Stack>

      <Stack direction="row" spacing="var(--spacing-6x)">
        <Stack
          direction="column"
          spacing="var(--spacing-6x)"
          sx={{ maxWidth: 840 }}
        >
          <StageCardPreview
            values={values}
            thumbnailImage={getImageSrc(values?.primaryThumbnail ?? "")}
          />
          <StageVideoPreview values={values} />
          <Gallery images={galleryImages} />
        </Stack>
      </Stack>

      <Stack spacing={3} mt={6}>
        <Box display="flex" justifyContent="space-between" mt={3} gap={2}>
          <Button
            onClick={onBack}
            variant="outlined"
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              textTransform: "none",
              px: 4,
              color: "#6366F1",
              borderColor: "#6366F1",
              "&:hover": { backgroundColor: "#EEF2FF" },
            }}
          >
            Previous
          </Button>

          <Stack gap={2} direction="row">
            <Button
              onClick={() => {
                setFieldValue("status", "Draft");
                handleSubmit();
              }}
              variant="outlined"
              fullWidth
              sx={{
                borderRadius: "var(--spacing-3x)",
                font: "var(--semibold-md)",
                textTransform: "none",
                px: 4,
                background: "var(--neutral-50)",
                color: "var(--neutral-900)",
                borderColor: "var(--neutral-200)",
                whiteSpace: "nowrap",
                height: "44px",
                "&:hover": {
                  boxShadow: "0 4px 14px rgba(99, 102, 241, 0.3)",
                },
              }}
            >
              Save as Draft
            </Button>
            <Button
              disabled={isSubmitting}
              onClick={() => {
                setFieldValue("status", "Active");
                handleSubmit();
              }}
              variant="contained"
              fullWidth
              sx={{
                borderRadius: 2,
                font: "var(--semibold-md)",
                textTransform: "none",
                whiteSpace: "nowrap",
                px: 4,
                background: "linear-gradient(90deg, #6366F1 0%, #9F03FF 100%)",
                color: "var(--neutralWhite)",
                height: "44px",
                "&:hover": {
                  boxShadow: "0 4px 14px rgba(99, 102, 241, 0.3)",
                },
                "&:disabled": {
                  color: "var(--neutral-500)",
                },
              }}
            >
              {isSubmitting ? "Publishing..." : "Publish Now"}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default StepFour_StageReviewAndPublish;
